import { render } from "./support-case-table.vue?vue&type=template&id=15b9ea98"
import script from "./support-case-table.vue?vue&type=script&lang=js"
export * from "./support-case-table.vue?vue&type=script&lang=js"

import "./support-case-table.vue?vue&type=style&index=0&id=15b9ea98&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__